import { Switch, Tooltip } from '@mui/material';

const labels = ['Opportunity Assigned', 'Opportunity Status Changes', 'Chat Mentions'];

export default function EmailSettings() {
    return labels.map(label => (
        <div className="hive-settings-toggle-row" key={label}>
            <div><p className="hive-settings-label">{label}</p></div>
            <Tooltip title="To configure this functionality please contact your administrator">
                <span tabIndex={0} aria-label={`${label} email settings unavailable`}>
                    <Switch disabled checked={false} inputProps={{ 'aria-label': label }} />
                </span>
            </Tooltip>
        </div>
    ));
}
